import clsx from 'clsx';
import { OverlayScrollbarsComponent } from 'overlayscrollbars-react';
import React from 'react';
import { useTranslation } from 'react-i18next';

interface SidebarProps {
  position?: 'left' | 'right';
  className?: string;
  fixedHeader?: React.ReactNode;
  /** Always-visible footer below the scrollable nav (e.g. shortcuts + version). */
  fixedFooter?: React.ReactNode;
  children: React.ReactNode;
}

const Sidebar = ({
  position = 'left',
  className,
  fixedHeader,
  fixedFooter,
  children,
}: SidebarProps) => {
  const { t } = useTranslation();

  return (
    <aside
      aria-label={t('a11y.mainNavigation')}
      className={clsx(
        'bg-background fixed top-[var(--app-header-stack-height,3.5rem)] bottom-0 z-50 flex w-[60px] flex-col overflow-hidden transition-all duration-300 lg:w-[205px]',
        position === 'right' ? 'right-0' : 'left-0',
        className,
      )}
    >
      <div className="flex h-full flex-col pt-4 text-white">
        {fixedHeader && <div className="mb-2 shrink-0">{fixedHeader}</div>}
        <div className="relative min-h-0 flex-1">
          <OverlayScrollbarsComponent
            style={{ position: 'absolute', inset: 0 }}
            options={{
              paddingAbsolute: true,
              scrollbars: {
                autoHide: 'leave',
                autoHideDelay: 100,
              },
            }}
            defer
          >
            <div className="pb-4">{children}</div>
          </OverlayScrollbarsComponent>
        </div>
        {fixedFooter && <div className="shrink-0">{fixedFooter}</div>}
      </div>
    </aside>
  );
};

export default Sidebar;
